// extracted by mini-css-extract-plugin
export var bubble = "_46-0";
export var container = "_46-f";
export var contrastBorder = "_46-g";
export var greyOut = "_46-2";
export var initialsColor0 = "_46-3";
export var initialsColor1 = "_46-4";
export var initialsColor10 = "_46-d";
export var initialsColor11 = "_46-e";
export var initialsColor2 = "_46-5";
export var initialsColor3 = "_46-6";
export var initialsColor4 = "_46-7";
export var initialsColor5 = "_46-8";
export var initialsColor6 = "_46-9";
export var initialsColor7 = "_46-a";
export var initialsColor8 = "_46-b";
export var initialsColor9 = "_46-c";
export var initialsWrapper = "_46-1";
export var large = "_46-l";
export var medium = "_46-k";
export var mediumSmall = "_46-j";
export var mediumSmallMedium = "_46-o";
export var micro = "_46-h";
export var small = "_46-i";
export var tiny = "_46-n";
export var xTiny = "_46-m";